import { KonsoleUser } from 'app/types/users/konsole'

export const connectedUser: KonsoleUser = {
    id: 167,
    username: 'tommy.ledev',
    is_superuser: true,
    first_name: 'Paul',
    last_name: 'LEDEV',
    email: 'paul.ledev@e-thik.com',
    is_staff: true,

    groups: [],
    profil: {
        client: [],

        avatar: '/media/avatars/default.png',
    },
}
